/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 *  A review's private feedback: only the answers and ratings marked private in the schema, not the
 *  review's full public content.
 */

export let ComHubspotReviewsModelsAbstractGenerateTitleError;
(function (_ComHubspotReviewsModelsAbstractGenerateTitleError) {})(ComHubspotReviewsModelsAbstractGenerateTitleError || (ComHubspotReviewsModelsAbstractGenerateTitleError = {}));
export let ComHubspotReviewsModelsAbstractGetPrivateFeedbackError;
(function (_ComHubspotReviewsModelsAbstractGetPrivateFeedbackError) {})(ComHubspotReviewsModelsAbstractGetPrivateFeedbackError || (ComHubspotReviewsModelsAbstractGetPrivateFeedbackError = {}));
export let ComHubspotReviewsModelsAbstractGetSummaryError;
(function (_ComHubspotReviewsModelsAbstractGetSummaryError) {})(ComHubspotReviewsModelsAbstractGetSummaryError || (ComHubspotReviewsModelsAbstractGetSummaryError = {}));
export let ComHubspotReviewsModelsAbstractReviewMutationError;
(function (_ComHubspotReviewsModelsAbstractReviewMutationError) {})(ComHubspotReviewsModelsAbstractReviewMutationError || (ComHubspotReviewsModelsAbstractReviewMutationError = {}));
export let ComHubspotReviewsModelsAbstractReviewTypeError;
(function (_ComHubspotReviewsModelsAbstractReviewTypeError) {})(ComHubspotReviewsModelsAbstractReviewTypeError || (ComHubspotReviewsModelsAbstractReviewTypeError = {}));
export let ComHubspotReviewsModelsAbstractReviewabilityError;
(function (_ComHubspotReviewsModelsAbstractReviewabilityError) {})(ComHubspotReviewsModelsAbstractReviewabilityError || (ComHubspotReviewsModelsAbstractReviewabilityError = {}));
export let ComHubspotReviewsModelsAbstractSearchReviewsError;
(function (_ComHubspotReviewsModelsAbstractSearchReviewsError) {})(ComHubspotReviewsModelsAbstractSearchReviewsError || (ComHubspotReviewsModelsAbstractSearchReviewsError = {}));
export let ComHubspotReviewsModelsThemesAbstractGetThemesError;
(function (_ComHubspotReviewsModelsThemesAbstractGetThemesError) {})(ComHubspotReviewsModelsThemesAbstractGetThemesError || (ComHubspotReviewsModelsThemesAbstractGetThemesError = {}));
export const generateTitleRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'generateTitle',
  auth: 'external',
  fingerprint: 'U93SYO6Zbz_mxBCl8KDHlJG0DHPqwZAw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummaryRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getSummary',
  auth: 'external',
  fingerprint: 'w4ShM0OOxZaic1v6FGKGHm5znO6Jte-P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEditabilityRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getEditability',
  auth: 'external',
  fingerprint: 'DhzmpX6gkwPdtK6GeSw-g-dNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThemesRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getThemes',
  auth: 'external',
  fingerprint: 'fMDThFkFbqwnKDiSpQZsP-C6RBaWvYMU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchReviewsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviews',
  auth: 'external',
  fingerprint: '2zDvX7GKho8SRgbVqzapH-C7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchReviewsLegacyRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviewsLegacy',
  auth: 'external',
  fingerprint: '2zDvX7GKho9SQ0bXLYDdhuC7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkReviewabilityRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'checkReviewability',
  auth: 'external',
  fingerprint: 'm9UvA5F-w-aOUe2e_r4XmdPzNCIu_Fnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOverallStatsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStats',
  auth: 'external',
  fingerprint: 'qHUH2DQ4JSnhj_TzWtwlnbO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOverallStatsBatchRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStatsBatch',
  auth: 'external',
  fingerprint: 'xtMhahMw4zEUuyWX9vOqebO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPrivateFeedbackRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getPrivateFeedback',
  auth: 'external',
  fingerprint: 'kBsrBKihGF9b1GUijSNljrF3tT30u0iZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewRequestEmailTokensRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewRequestEmailTokens',
  auth: 'external',
  fingerprint: 'AAAAAAAAAACINleg96NDbZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewTagsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewTags',
  auth: 'external',
  fingerprint: 'AAAAAAAAAABx42BfnpCCI5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewerDisplayNameRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewerDisplayName',
  auth: 'external',
  fingerprint: 'AAAAAAAAAACqMt9eT6GjPedNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnReviewsByAppIdsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOwnReviewsByAppIds',
  auth: 'external',
  fingerprint: 'A3IiYp_GBBsupCHY246mE-dNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};